import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { isPromise } from "@insightfulscience/shared-utils/fn";
import ApplicationError from "@insightfulscience/smart-react/ApplicationError";
import AppError from "./AppError";
import { getUnexpectedError } from "../graphql-local/unexpectedError";
import { notifySentry } from "../sentry";
import useCurrentPath from "../utils/nav-hooks/useCurrentPath";
import useQueryString from "../utils/nav-hooks/useQueryString";

const withErrorHandlingHoC = Component => {
	const WithErrorHandling = ({ error, ...props }) => {
		const { data } = useQuery(getUnexpectedError);
		const asPath = useCurrentPath();
		const query = useQueryString();

		React.useEffect(() => {
			if (data?.unexpectedError == null) return;

			notifySentry(
				ApplicationError.of(data.unexpectedError), // error
				{ asPath, query },
			);
		}, [data?.unexpectedError]);

		if (error == null && data?.unexpectedError == null) {
			return <Component {...props} />;
		}

		return <AppError error={error || ApplicationError.of(data.unexpectedError)} />;
	};

	WithErrorHandling.propTypes = AppError.propTypes;

	WithErrorHandling.getInitialProps = context => {
		try {
			const props = Component.getInitialProps ? Component.getInitialProps(context) : {};
			return isPromise(props)
				? props.catch(err => AppError.getInitialProps({ ...context, err }))
				: props;
		} catch (err) {
			return AppError.getInitialProps({ ...context, err });
		}
	};

	return WithErrorHandling;
};

export default withErrorHandlingHoC;
